// src/routes.js
import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TableChartIcon from "@mui/icons-material/TableChart";
import PersonIcon from "@mui/icons-material/Person";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <DashboardIcon />,
    route: "/dashboard",
  },
  {
    type: "collapse",
    name: "Tables",
    key: "tables",
    icon: <TableChartIcon />,
    route: "/tables",
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <PersonIcon />,
    route: "/profile",
  },
];

export default routes;
